import produce from 'immer'
import * as actionTypes from './constants'

const defaultState = {
  homeNewsList: [],
}

export default (state = defaultState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actionTypes.CHANGE_HOME_NEWS_LIST:
      draft.homeNewsList = action.data
      break
    default:
      break
  }
})
